import React, { useState, useEffect } from 'react';
import './InstagramFeed.css';

const INSTAGRAM_PROFILE = 'https://www.instagram.com/alkas_cake_walk_/';

const INSTAGRAM_POSTS = [
  { id: 'DSHlOiDiSDi', type: 'reel' },
  { id: 'DO8T934ibBh', type: 'reel' },
  { id: 'DMvSnJZpmDK', type: 'reel' },
  { id: 'DEY7usgiu6G', type: 'post' },
  { id: 'DBX1rPNCVll', type: 'post' },
  { id: 'DIkrbfeJ-Ei', type: 'post' },
];

const InstagramFeed = () => {
  const [visiblePosts, setVisiblePosts] = useState(3);
  const [loadedPosts, setLoadedPosts] = useState({});

  useEffect(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, [visiblePosts]);

  const handleLoadMore = () => {
    setVisiblePosts(prev => Math.min(prev + 3, INSTAGRAM_POSTS.length));
  };

  const handleIframeLoad = (id) => {
    setLoadedPosts(prev => ({ ...prev, [id]: true }));
  };

  return (
    <section className="instagram-section">
      <div className="section-header">
        <h2 className="section-title">Follow Us on Instagram</h2>
        <p className="section-subtitle">
          See our latest creations and behind-the-scenes moments
        </p>
      </div>
      
      <div className="instagram-grid">
        {INSTAGRAM_POSTS.slice(0, visiblePosts).map((post) => (
          <div key={post.id} className="instagram-embed-container">
            <iframe
              src={`https://www.instagram.com/${post.type === 'reel' ? 'reel' : 'p'}/${post.id}/embed`}
              className={`instagram-embed-iframe ${loadedPosts[post.id] ? 'loaded' : ''}`}
              title={`Instagram ${post.type} ${post.id}`}
              frameBorder="0"
              scrolling="no"
              onLoad={() => handleIframeLoad(post.id)}
            />
          </div>
        ))}
      </div>

      {visiblePosts < INSTAGRAM_POSTS.length && (
        <div className="instagram-load-more">
          <button className="instagram-load-more-btn" onClick={handleLoadMore}>
            Load More
          </button>
        </div>
      )}

      <div className="instagram-follow">
        <a
          href={INSTAGRAM_PROFILE}
          target="_blank"
          rel="noopener noreferrer"
          className="instagram-follow-btn"
        >
          <i className="fab fa-instagram" style={{ marginRight: 8 }}></i>
          @alkas_cake_walk_
        </a>
      </div>
    </section>
  );
};

export default InstagramFeed;